import React, { createContext, useContext, useState } from 'react';
import { inPersistentStore } from "../utils/storage.util";

type AppContextState = {
    setRenderIncludeScreen: React.Dispatch<React.SetStateAction<boolean>>;
    setRenderIncludePerfilOrLista: React.Dispatch<React.SetStateAction<boolean>>;
    setFiltersDashboard: React.Dispatch<React.SetStateAction<any>>;
    setManageItem: React.Dispatch<React.SetStateAction<object>>;
    setNewLayout: React.Dispatch<React.SetStateAction<boolean>>;
    renderIncludeScreen: boolean;
    renderIncludePerfilOrLista: boolean;
    filtersDashboard: any;
    manageItem: object;
    newLayout: boolean;
};

const AppContext = createContext<AppContextState | null>(null);

type AppProviderProps = {
    children?: React.ReactNode;
};

export const AppProvider = ({children}: AppProviderProps) => {
    const persistedNewLayout = inPersistentStore.getItem('newLayout');
    const isNewLayout = typeof persistedNewLayout === 'boolean' ? persistedNewLayout : true;
    const [renderIncludeScreen, setRenderIncludeScreen] =
        useState<boolean>(false);
    const [renderIncludePerfilOrLista, setRenderIncludePerfilOrLista] =
        useState<boolean>(false);
    const [filtersDashboard, setFiltersDashboard] = useState<any>({});
    const [manageItem, setManageItem] = useState<object>({});
    const [newLayout, setNewLayout] = useState<boolean>(isNewLayout);



    return (
        <AppContext.Provider
            value={{
                renderIncludeScreen,
                setRenderIncludeScreen,
                renderIncludePerfilOrLista,
                setRenderIncludePerfilOrLista,
                filtersDashboard,
                setFiltersDashboard,
                manageItem,
                setManageItem,
                newLayout,
                setNewLayout,
            }}
        >
            {children}
        </AppContext.Provider>
    );
};

export const useApp = (): AppContextState => {
    const context = useContext(AppContext);

    if (context === null) {
        throw new Error(`useApp must be used within a AppProvider`);
    }

    return context;
};
